<template>
  <div id="app">
    <Header @show-about="setShowAbout"/>
    <div class="container site-wrap">
      <div class="row">
        <div class="col-sm-4">
          <Search/>
          <SearchSource/>
        </div>
        <div class="col-sm-8"><Results /></div>
      </div>  
    </div>
     <about-dialog v-model="showAbout"></about-dialog>
    <mobile-footer @showHowDialog="showAbout=true" :englishSupported="false" :howDialog="true"></mobile-footer>  
  </div>
</template>

<script>
import Header from '@/components/header'
import Search from '@/components/search'
import SearchSource from '@/components/SearchSource'
import Results from '@/components/results'
import AboutDialog from '@/components/HowDialog'

export default {
  name: 'App',
  components: {
    Header,
    AboutDialog,
    Search,
    SearchSource,
    Results
  },
  data() {
    return {
      bibleResultsLength: 0,
      talmudResultsLength: 0,
      showAbout: false,
    }
  },  
  methods: {
    setShowAbout (val) {
      this.showAbout = val
    }
  }
}
</script>
<style>
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active  {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  @font-face {
    font-family: 'mft_narkisclassic';
    src: url('assets/fonts/mft_narkisclassic-regular.woff') format('woff');
    font-style: normal;
    font-weight: normal;
    text-rendering: optimizeLegibility;
  }
  @font-face {
    font-family: 'mft_narkisclassic';
    src: url('assets/fonts/MFTW_NarkisClassicBold.woff') format('woff');
    font-style: normal;
    font-weight: bold;
  }
  .f-narkis{
    font-family: Roboto, mft_narkisclassic, sans-serif;
    line-height: 1.5;
  }
</style>
<style lang="scss" scoped>
  @media only screen and (max-width: 767px) {
    .site-wrap{
      min-height: calc(100vh - 200px);
    }
  }  
</style>
